import React, { Component } from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { TrendingUp as TrendingUpIcon } from "@material-ui/icons";
import styled from "styled-components";
import _ from "lodash";
import ListItem from "../../waybee-ui/List/ListItem";
import Group from "../../waybee-ui/Group";
import Heading from "../../waybee-ui/Heading/Heading";
import IndicatorsService from "../../services/IndicatorsService";
import Loading from "../../components/Loading";

const SidebarContainer = styled.div`
  background-color: #fff;
  border-right: 1px solid #f2f2f2;
  min-height: 100%;

  .MuiListItem-root.Mui-selected {
    background-color: ${({ theme }) =>
      theme.color?.primary?.light || "#f5f5f5"};
    border-left: 3px solid
      ${({ theme }) => theme.color?.primary?.dark || "#1976d2"};
  }
`;

const ContentContainer = styled.div`
  padding: 30px;
`;

const PlaceholderText = styled.div`
  color: rgba(0, 0, 0, 0.5);
  font-size: 16px;
  text-align: center;
  padding: 40px 20px;
`;

const GraphCard = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  height: 500px;
  overflow: hidden;
  position: relative;
`;

const GraphContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;

  iframe {
    border: none;
    width: 100%;
    height: calc(
      100% + 60px
    ); /* Adiciona espaço extra para "cortar" o footer do Metabase */
  }
`;

class Indicators extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: "engajamento",
      loadingGraph: false,
      loadingAccessionGraph: false,
      engagementGraph: null,
      accessionGraph: null
    };
  }

  componentDidMount() {
    const { setTitle } = this.props;
    setTitle("Indicadores");
    this.getEngagementGraph();
    this.getAccessionGraph();
  }

  getEngagementGraph = async () => {
    this.setState({ loadingGraph: true });
    try {
      const engagementGraph = await IndicatorsService.getEngagementGraph();
      this.setState({ engagementGraph });
    } catch (e) {
      const { openAlert } = this.props;
      console.error(e);
      const message = _.get(
        e,
        "response.data.error.message",
        "Erro ao buscar gráfico de engajamento"
      );
      if (openAlert) {
        openAlert({
          status: "error",
          message
        });
      }
    } finally {
      this.setState({ loadingGraph: false });
    }
  };

  getAccessionGraph = async () => {
    this.setState({ loadingAccessionGraph: true });
    try {
      const accessionGraph = await IndicatorsService.getAccessionGraphs();
      this.setState({ accessionGraph });
    } catch (e) {
      console.error(e);
    } finally {
      this.setState({ loadingAccessionGraph: false });
    }
  };

  handleOptionClick = option => {
    this.setState({ selectedOption: option });
    const { engagementGraph } = this.state;
    if (option === "engajamento" && !engagementGraph) {
      this.getEngagementGraph();
    }
  };

  renderEngajamentoContent = () => {
    const {
      loadingGraph,
      loadingAccessionGraph,
      engagementGraph,
      accessionGraph
    } = this.state;

    return (
      <div>
        <Heading level={2} icon={TrendingUpIcon} gutterBottom>
          Indicadores de Engajamento
        </Heading>
        <Grid container spacing={3}>
          {accessionGraph && accessionGraph.dashboard && (
            <Grid item xs={12}>
              <GraphCard>
                {loadingAccessionGraph && <Loading />}
                {!loadingAccessionGraph && (
                  <GraphContainer>
                    <iframe
                      title="Gráfico de Engajamento - Dashboard"
                      src={accessionGraph.dashboard}
                      frameBorder={0}
                      allowTransparency
                    />
                  </GraphContainer>
                )}
              </GraphCard>
            </Grid>
          )}
          {engagementGraph && engagementGraph.engagementNotAccessUsers && (
            <Grid item xs={12}>
              <GraphCard>
                {loadingGraph && <Loading />}
                {!loadingGraph && (
                  <GraphContainer>
                    <iframe
                      title="Gráfico de Engajamento - Usuários que não acessaram"
                      src={engagementGraph.engagementNotAccessUsers}
                      frameBorder={0}
                      allowTransparency
                    />
                  </GraphContainer>
                )}
              </GraphCard>
            </Grid>
          )}
          {!loadingGraph &&
            !loadingAccessionGraph &&
            (!engagementGraph || !engagementGraph.engagementNotAccessUsers) &&
            (!accessionGraph || !accessionGraph.dashboard) && (
              <Grid item xs={12}>
                <PlaceholderText>
                  Gráficos de engajamento não disponíveis no momento.
                </PlaceholderText>
              </Grid>
            )}
        </Grid>
      </div>
    );
  };

  renderContent = () => {
    const { selectedOption } = this.state;

    switch (selectedOption) {
      case "engajamento":
        return this.renderEngajamentoContent();
      default:
        return (
          <PlaceholderText>
            Selecione uma opção no menu lateral para visualizar os indicadores.
          </PlaceholderText>
        );
    }
  };

  render() {
    const { selectedOption } = this.state;

    return (
      <Grid container spacing={0}>
        <Grid item xs={12} md={3}>
          <SidebarContainer>
            <Group p={0}>
              <ListItem
                icon={<TrendingUpIcon />}
                button
                selected={selectedOption === "engajamento"}
                onClick={() => this.handleOptionClick("engajamento")}
              >
                Engajamento
              </ListItem>
            </Group>
          </SidebarContainer>
        </Grid>
        <Grid item xs={12} md={9}>
          <ContentContainer>{this.renderContent()}</ContentContainer>
        </Grid>
      </Grid>
    );
  }
}

Indicators.propTypes = {
  setTitle: PropTypes.func.isRequired,
  openAlert: PropTypes.func
};

Indicators.defaultProps = {
  openAlert: null
};

export default Indicators;
